// src/state/menu/types/discounts_types.ts
var TApplyTo = /* @__PURE__ */ ((TApplyTo2) => {
  TApplyTo2["ITEM"] = "item";
  TApplyTo2["ORDER"] = "order";
  return TApplyTo2;
})(TApplyTo || {});
var TDiscountType = /* @__PURE__ */ ((TDiscountType2) => {
  TDiscountType2["PERCENT"] = "percent";
  TDiscountType2["FIXED"] = "fixed";
  TDiscountType2["OVERRIDE"] = "override";
  return TDiscountType2;
})(TDiscountType || {});
var TDiscountTaxesType = /* @__PURE__ */ ((TDiscountTaxesType2) => {
  TDiscountTaxesType2["APPLY_BEFORE"] = "applyBeforeTaxes";
  TDiscountTaxesType2["APPLY_AFTER"] = "applyAfterTaxes";
  return TDiscountTaxesType2;
})(TDiscountTaxesType || {});

export { TApplyTo, TDiscountTaxesType, TDiscountType };
